import styled from 'styled-components';

export const TagWrapper = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  .tag-element {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.2em 0.5em;
    text-decoration: none;
    margin: 0 0.5em;
    min-width: 4rem;
    background-color: blueviolet;
    border-radius: 0.25rem;
    .tag-link {
      text-decoration: none;
      display: flex;
      align-items: center;
      font-size: 13px;
    }
    .tag-link::before {
      display: none;
    }
    transition: filter 300ms ease;
  }
  .tag-element:hover {
    cursor: pointer;
    filter: brightness(90%);
    transition: filter 300ms ease;
  }
`;
